import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";

class AccordionNav extends Component {
  focusNav = () => {
    this.myRef && this.myRef.focus();
  };

  generateLink = (pageId) => {
    let page = this.props.content.pages.find(
      (pageObj) => pageObj.id === pageId
    );

    return (
      <NavItem key={page.id}>
        <Nav.Link
          eventKey={page.id}
          href={`${this.props.match.url}/${page.id}`}
        >
          {page.name}
        </Nav.Link>
      </NavItem>
    );
  };

  buildSection = (section) => {
    return (
      <AccordionItem key={section.id} uuid={section.id}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <a
              ref={(focus) => {
                if (section.id === 1) {
                  this.myRef = focus;
                  this.focusNav();
                }
              }}
            >
              {section.title}
            </a>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <Nav
            variant="pills"
            activeKey={this.props.currentPage}
            className="flex-column"
          >
            {section.contentRange.map((pageId) => this.generateLink(pageId))}
          </Nav>
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    return (
      <Accordion
        allowMultipleExpanded
        allowZeroExpanded
        preExpanded={[1, 2, 3]}
      >
        {this.props.content.sections.map((section) =>
          this.buildSection(section)
        )}
      </Accordion>
    );
  }
}

export default withRouter(AccordionNav);
